import { createFileRoute } from '@tanstack/react-router'
import { AdminGuard } from '@/components/admin-guard'
import { ClientSettingsView } from '@/features/clients/ClientSettingsView'

function ClientSettingsRoute() {
  const { companyId } = Route.useParams()
  return (
    <AdminGuard>
      <ClientSettingsView companyId={companyId} />
    </AdminGuard>
  )
}

export const Route = createFileRoute('/clients/$companyId/settings')({ component: ClientSettingsRoute })
